import {
  getApiAccounts,
  getApiContacts,
  getApiCredentials,
  getApiMembers,
  getApiParticipants,
  getApiUsers,
} from 'reduxes/slices/api/selectors'
import { getSelectedTopicId } from 'reduxes/slices/selected/selectors'
import { createSelector } from 'reselect'

export const getCurrentUserId = (state) => state.current && state.current.userId
export const getCurrentHandle = (state) => state.current && state.current.handle
export const getCurrentTeammateHandle = (state) =>
  state.current && state.current.teammate_handle
export const getCurrentMemberId = (state) =>
  state.current && state.current.memberId
export const getCurrentAccountId = (state) =>
  state.current && state.current.accountId
export const getCurrentCredentialId = (state) =>
  state.current && state.current.credentialId
export const getCurrentTitle = (state) => state.current && state.current.title
export const getCurrentSiteName = (state) => state.current && state.current.chargeBeeSite
export const getCurrentEnvironment = (state) => state.current && state.current.environment

export const getCurrentUser = createSelector(
  [getCurrentUserId, getApiUsers],
  (currentUserId, users) => {
    return users[currentUserId]
  },
)
export const getCurrentParticipantForSelectedTopic = createSelector(
  [getCurrentTeammateHandle, getSelectedTopicId, getApiParticipants],
  (currentTeammateHandle, selectedTopicId, participants) => {
    if (selectedTopicId === 0) return undefined

    return Object.values(participants).find(
      (p) =>
        p.handle === currentTeammateHandle &&
        p.parent_type === 'Topic' &&
        p.parent_id === selectedTopicId,
    )
  },
)
export const getCurrentTeamParticipantForSelectedTopic = createSelector(
  [getCurrentHandle, getSelectedTopicId, getApiParticipants],
  (currentHandle, selectedTopicId, participants) => {
    if (selectedTopicId === 0) return undefined

    return Object.values(participants).find(
      (p) =>
        p.handle === currentHandle &&
        p.parent_type === 'Topic' &&
        p.parent_id === selectedTopicId,
    )
  },
)
export const getCurrentAccount = createSelector(
  [getCurrentAccountId, getApiAccounts],
  (currentAccountId, accounts) => {
    return accounts && accounts[currentAccountId]
  },
)
export const getCurrentMember = createSelector(
  [getCurrentMemberId, getApiMembers],
  (currentMemberId, members) => {
    return members && members[currentMemberId]
  },
)

export const isNotPlaceholderPlan = createSelector(
  [getCurrentAccountId, getApiAccounts],
  (currentAccountId, accounts) => {
    const account = accounts && accounts[currentAccountId]
    return account.plan !== 'placeholder'
  },
)

export const isConfirmedSelector = createSelector(
  [getCurrentCredentialId, getApiCredentials],
  (currentCredentialId, credentials) => {
    const credential = credentials && credentials[currentCredentialId]
    return credential?.is_confirmed
  },
)

export const getCurrentTeammateContact = createSelector(
  [getCurrentTeammateHandle, getApiContacts],
  (currentTeammateHandle, contacts) => {
    return (
      contacts &&
      Object.values(contacts).find((c) => c.email === currentTeammateHandle)
    )
  },
)
